"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var InformationTip_1 = require("../../../../../../../common/InformationTip");
var LoadingContainer_1 = require("../../../../../../../common/LoadingContainer");
var DebtRequestLitigationForm_1 = require("./DebtRequestLitigationForm");
var DebtRequestLitigationContent = function (props) {
    return (React.createElement("section", null,
        React.createElement("div", { className: "container" },
            React.createElement("div", { className: "modal-header flex-row" },
                React.createElement("h3", null, "Advance Debt Beyond rradarrecover"),
                React.createElement("div", { className: "flex-row" },
                    React.createElement("div", { className: "isPointer", onClick: function () {
                            props.handleRequestLitigation();
                        } },
                        React.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'times'] }))))),
        React.createElement("div", { className: "container" },
            React.createElement("p", null, "If having followed Stages One and Two you need more support to achieve\n          payment of the debt you can advance the debt beyond rradarrecover."),
            React.createElement(InformationTip_1.default, null,
                React.createElement("div", null, "Make sure to read rradar's huid to Alternative Dispute Resoloution\n            (ADR) and your Legal Action Outlook to get a sense of your best\n            option.")),
            React.createElement(LoadingContainer_1.default, { render: function (config) {
                    return React.createElement(DebtRequestLitigationForm_1.default, __assign({}, config, props));
                } }))));
};
exports.default = DebtRequestLitigationContent;
